import { useList } from '@refinedev/core';

export enum MigrationStatus {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export type Company = {
  id: string;
  name: string;
  tenantName: string;
  fcaFirmReferenceNumbers?: { id: string; number: string }[];
  finioFirmName?: string | null;
  clientsCount: number;
  migrationStatus: MigrationStatus;
};

export const useCompanies = () => {
  const { data, isLoading, isError, error } = useList<Company>({
    resource: 'admin/companies',
  });

  return {
    companies: data?.data,
    isLoading,
    isError,
    error,
  };
};
